// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"891ff79a","521":"ca3231b0","768":"8c78cf2f","812":"5d0e1ca7","834":"0a7b2fa9","938":"456e15e4","955":"ba0f4535","973":"c08304d9"}[chunkId] + ".chunk.js";
};